const LANGFUSE_TARGETS_BY_HOST: Record<string, { baseUrl: string; projectId: string }> = {
  'autoscript.ai': { baseUrl: 'https://langfuse.autoscript.ai', projectId: 'cmqrl4k0l0001v407m1393569' },
  'www.autoscript.ai': { baseUrl: 'https://langfuse.autoscript.ai', projectId: 'cmqrl4k0l0001v407m1393569' },
  'staging.autoscript.ai': {
    baseUrl: 'https://langfuse-staging.autoscript.ai',
    projectId: 'cmqhcqevi0006yp071kbrkbd4',
  },
  'demo.autoscript.ai': {
    baseUrl: 'https://langfuse-staging.autoscript.ai',
    projectId: 'cmpla6rd20006ya08vgb20kh3',
  },
};

export const getLangfuseSessionUrl = (jobId?: string | null) => {
  if (!jobId) {
    return null;
  }

  const target = LANGFUSE_TARGETS_BY_HOST[window.location.hostname] ?? {
    baseUrl: import.meta.env.VITE_LANGFUSE_BASE_URL,
    projectId: import.meta.env.VITE_LANGFUSE_PROJECT_ID,
  };

  if (!target.baseUrl || !target.projectId) {
    return null;
  }

  const baseUrl = target.baseUrl.replace(/\/$/, '');
  return `${baseUrl}/project/${encodeURIComponent(target.projectId)}/sessions/${encodeURIComponent(jobId)}`;
};
